module.exports = __webpack_public_path__ + "assets/images/project/menu/united-kingdom-thumb.jpg?v=605a73f7";